import {Component, OnDestroy, OnInit} from '@angular/core';
import { select, Store } from '@ngrx/store';
import * as UserActions from 'src/app/store/user/actions';
import * as Reducers from 'src/app/store/reducers';
import { ProtectedPrivacyService } from '../../../../../services/ui/protected-privacy.service';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { userPages } from '@app/pages/user/user.routes';
import { profilePages } from '@app/pages/profile/profile.routes';

@Component({
	selector: 'app-topbar-user-menu',
	templateUrl: './user-menu.component.html',
	styleUrls: ['./user-menu.component.scss']
})
export class TopbarUserMenuComponent implements OnInit, OnDestroy {
	badgeCount = 0;
	name: string;
	username: string;
	role: string;
	email: string;
	phone: string;

	public privacyMode = false;
	private subscription = new Subscription();

	constructor(
		private store: Store<never>,
		private privacyService: ProtectedPrivacyService,
		private router: Router
	) {

	}

	ngOnInit(): void {
		this.subscription.add(this.privacyService.toggleChange$().subscribe(status => this.privacyMode = status ));
		this.subscription.add(this.store.pipe(select(Reducers.getUser)).subscribe(state => {
			this.name = state.name || state.username;
			this.username = state.username;
			this.role = (state.roles || [])[0];
			this.email = state.email;
		}));
	}

	ngOnDestroy(): void {
		this.subscription.unsubscribe();
	}

	logout(): void {
		this.store.dispatch(new UserActions.Logout());
	}

	lock(): void {
		this.store.dispatch(new UserActions.LockUser(this.email));
	}

	editProfile(): void {
		this.router.navigate([profilePages.root.base()]);
	}
}
